import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";


const HtmlContent = ({htmlData}) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    // Assuming htmlData is the HTML string you fetched from your database
    const sanitizedHtml = DOMPurify.sanitize(htmlData); // Sanitize HTML to prevent XSS
    setContent(sanitizedHtml);
  }, [htmlData]);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      style={{ whiteSpace: "pre-line" }} // Helps preserve spacing
    ></div>
  );
};

export default HtmlContent;
